var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","md9":""}},[_c('cld-video',{staticClass:"mb-4",attrs:{"publicId":_vm.videoProviderId,"width":"100%","controls":"true"}},[_c('cld-transformation',{attrs:{"width":"1024","crop":"scale"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }